import { InjectionToken } from '@angular/core';

export const AUTH_ROUTES = new InjectionToken<AuthRoutesConfig>('AUTH_ROUTES');

export interface AuthRoutesConfig {
  login: string;
  unauthorized: string;
}
